import Vue from "vue";
import axios from "axios";
import Cookies from "js-cookie";
import VueRouter from "vue-router";
import flatPickr from "vue-flatpickr-component"; // 日期控件
import VeeValidate from "vee-validate";
import store from "@common/store";
import router from "@common/routers";
import App from "./App.vue";
import VueLazyload from "vue-lazyload"; // 图片懒加载
import {
  Badge,
  Button,
  Carousel,
  CarouselItem,
  Cascader,
  DatePicker,
  Input,
  Loading,
  Option,
  Select,
  Table,
  TableColumn
} from "element-ui";

import "@common/filters";
import "@common/http";
import "@common/mixins";
import "@assets/less/style.less";
import "flatpickr/dist/flatpickr.css";
import "@assets/less/initElementUi.less";
import "element-ui/lib/theme-chalk/index.css";

Vue.prototype.$http = axios;
Vue.prototype.Cookies = Cookies;
Vue.use(VueRouter);
Vue.use(flatPickr);
Vue.use(VeeValidate, {
  classes: true
});
Vue.use(VueLazyload, {
  loading: require("@assets/images/loading.gif"),
  error: require("@assets/images/no_image.png")
});
Vue.use(Badge)
  .use(Button)
  .use(Carousel)
  .use(CarouselItem)
  .use(Cascader)
  .use(DatePicker)
  .use(Input)
  .use(Loading)
  .use(Option)
  .use(Select)
  .use(Table)
  .use(TableColumn);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
  data: {
    eventBus: new Vue()
  }
}).$mount("#app");